export const config = {
	default: 'prod',
	mp: {
		host: 'https://mp.bigbangmarkerdev.info',
		apiCache: false,
		routeCacheExpire: 0,
	},
	beta: {
		host: 'https://beta.bigbang.si',
		apiCache: false,
		routeCacheExpire: 0,
	},
	prod: {
		host: 'https://www.bigbang.si',
		apiCache: true,
		routeCacheExpire: 305, // 5 min
	},
	predprod: {
		host: 'https://predprod.bigbangmarkerdev.info',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},
	local: {
		host: 'https://beta.bigbang.si',
		apiCache: false,
		routeCacheExpire: 0,
	},
};
